import { useState } from 'react'
import { Footer } from '../components/Footer'
import imageCompression from 'browser-image-compression';


export const Home = () => {
    const [image, setImage] = useState("")
    const [imageFile, setImageFile] = useState("")
    const [compressedImage, setCompressedImage] = useState("")
    const [fileName, setFileName] = useState("")

    const handle = (e) => {
        const uploadImage = e.target.files[0]
        setImageFile(uploadImage)
        setImage(URL.createObjectURL(uploadImage))
        setFileName(uploadImage.name)
    }

    const handleCompressImage = (e) => {
        e.preventDefault()

        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 500,
            useWebWorker: true
        }
        if (options.maxSizeMB >= image / 1024) {
            alert('Oops🤫 the file cannot be compressed')
            return 0
        }

        let output;
        imageCompression(imageFile, options)
            .then((x) => {
                output = x;

                const downloadLink = URL.createObjectURL(output)
                setCompressedImage(downloadLink)
                console.log(fileName)
            })
    }

    return (
        <>
            <div className="sub-header">
                <div className="container">
                    <h1>Image Compressor - Odidor</h1>
                </div>
            </div>
            <div className="contact">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12" id="mainContent">
                            <div className="row box first">
                                <div className="box-header">
                                    <h3><strong><i className="fas fa-arrow-circle-up"></i></strong>Upload Image</h3>
                                    <p>Upload the image here ⬇ (Only jpg, png, pdf, max. 20Mb)</p>
                                </div>
                                <div className="col-md-12 col-sm-12 pb-2">
                                    {image ? (<img src={image} className="img-fluid rounded mx-auto d-block" />) : (<img src={"https://i.ibb.co/Mn13jQQ/empty.png"} className="img-fluid rounded mx-auto d-block" />)}

                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <input type="file" accept="image/*" onChange={(e) => handle(e)} />
                                    </div>
                                </div>
                            </div>

                            <div className="row pt-4 pb-4">
                                <div className="col-12">
                                    <button onClick={(e) => { handleCompressImage(e) }} className="btn-form-func">
                                        <span className="btn-form-func-content">Convert</span>
                                        <span className="icon"><i className="fas fa-compress-arrows-alt" aria-hidden="true"></i></span>
                                    </button>
                                </div>
                            </div>

                            <div className="row box">
                                <div className="box-header">
                                    <h3><strong><i className="fas fa-arrow-circle-down"></i></strong>Download Image</h3>
                                    <p>Download your compressed Image 🖼</p>
                                </div>
                                <div className="col-md-12 col-sm-12">
                                    {compressedImage ?
                                        (<img src={compressedImage} className="img-fluid rounded mx-auto d-block" />) :
                                        (<img src={"https://i.ibb.co/Mn13jQQ/empty.png"} className="img-fluid rounded mx-auto d-block" />)
                                    }
                                </div>
                            </div>

                            <div className="row pt-4 pb-4">
                                <div className="col-12">
                                    <a href={compressedImage} download={fileName}>
                                        <button className="btn-form-func">
                                            <span className="btn-form-func-content">Download</span>
                                            <span className="icon"><i className="fas fa-cloud-download-alt"></i></span>
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <Footer />
        </>
    )
}
